import Vue from "vue";
import loggingService from "../services/LoggingService";

export default {
  install() {
    // Vue Error Handler
    Vue.config.errorHandler = (error, vm, info) => {
      loggingService.logError("vue", error, {
        componentName: vm.$options.name,
        info,
        ...Object.fromEntries(
          Object.entries(vm.$props).map(([key, value]) => [
            `props_${key}`,
            JSON.stringify(value),
          ])
        ),
        route: vm.$route?.path,
      });
      console.error(error);
    };

    // Global JS Error Handler
    window.onerror = (message, source, lineno, colno, error) => {
      loggingService.logError("js", error || message, {
        source,
        lineno,
        colno,
      });
    };

    // Unhandled Promise Rejections
    window.onunhandledrejection = (event) => {
      loggingService.logError("promise", event.reason);
    };

    // Router hooks para tracking de navegação
    // Vue.prototype.$router.beforeEach((to, from, next) => {
    //   loggingService.logEvent("route_change", {
    //     from: from.path,
    //     to: to.path,
    //   });
    //   next();
    // });

    // Global method to log events
    Vue.prototype.$logEvent = (name, data) => {
      loggingService.logEvent(name, data);
    };

    // Método para log de interações do usuário
    Vue.directive("track-interaction", {
      bind(el, binding) {
        el.addEventListener("click", () => {
          loggingService.logEvent("user_interaction", {
            element: binding.value || el.tagName,
            type: "click",
          });
        });
      },
    });
  },
};
